export enum WORKLOAD_ROUTE_NAMES {
  WORKLOAD_INDEX = "workload-index",
  WORKLOAD_DELETED_INDEX = "workload-deleted-index",
}

export enum EWorkloadViewType {
  Active = "active",
  Deleted = "deleted",
}
